import React, { useState, useEffect, useMemo } from "react";
import { MapContainer, TileLayer, CircleMarker, useMapEvents } from "react-leaflet";
import { toast } from "react-toastify";
import axios from "axios";
import { GET_MAP_CENTER } from "../const";

const LocationClickHandler = ({ onLocationSelect }) => {
    useMapEvents({
        click(event) {
            onLocationSelect([event.latlng.lat, event.latlng.lng]);
        },
    });
    return null;
};

const DriverLocationPicker = () => {
    const [selectedLocation, setSelectedLocation] = useState(null);
    const [saving, setSaving] = useState(false);
    const [saved, setSaved] = useState(false);
    const [center, setCenter] = useState([54.9, 52.3]);

    // Get map center from API
    useEffect(() => {
        axios.get(GET_MAP_CENTER)
            .then(response => {
                const payload = response.data;
                if (payload && payload.web_app_map_center) {
                    const coords = payload.web_app_map_center.coordinates;
                    if (coords && coords.length === 2 && !isNaN(coords[0]) && !isNaN(coords[1])) {
                        setCenter([...coords].reverse());
                    }
                }
            })
            .catch(() => {});

        // Try IP geolocation
        fetch("https://ipapi.co/json/")
            .then(r => r.json())
            .then(data => {
                if (data.latitude && data.longitude) {
                    setCenter([data.latitude, data.longitude]);
                }
            })
            .catch(() => {});
    }, []);

    const saveLocation = async () => {
        if (!selectedLocation) return;
        setSaving(true);

        const maxApp = window.WebApp;
        const maxUserId = maxApp?.initDataUnsafe?.user?.id;

        if (!maxUserId) {
            toast.error("\u041d\u0435 \u0443\u0434\u0430\u043b\u043e\u0441\u044c \u043e\u043f\u0440\u0435\u0434\u0435\u043b\u0438\u0442\u044c \u043f\u043e\u043b\u044c\u0437\u043e\u0432\u0430\u0442\u0435\u043b\u044f");
            setSaving(false);
            return;
        }

        try {
            const resp = await fetch(window.location.origin + "/core/api/users/updateMaxDriverLocation/", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": "EnvToken 68df0d5bc31caef0327fbcd0686c09ccd35a5952",
                },
                body: JSON.stringify({
                    chat_id: maxUserId,
                    latitude: selectedLocation[0],
                    longitude: selectedLocation[1],
                }),
            });

            if (resp.ok) {
                setSaved(true);
                toast.success("\u041f\u043e\u0437\u0438\u0446\u0438\u044f \u0441\u043e\u0445\u0440\u0430\u043d\u0435\u043d\u0430!");
                setTimeout(() => {
                    try { window.WebApp?.close(); } catch(e) { window.close(); }
                }, 1500);
            } else {
                toast.error("\u041e\u0448\u0438\u0431\u043a\u0430 \u0441\u043e\u0445\u0440\u0430\u043d\u0435\u043d\u0438\u044f");
            }
        } catch (e) {
            toast.error("\u041e\u0448\u0438\u0431\u043a\u0430 \u0441\u0435\u0442\u0438");
        }
        setSaving(false);
    };

    return (
        <div style={{ height: "100vh", display: "flex", flexDirection: "column", background: "#0f0f23" }}>
            <div style={{
                padding: "12px 16px",
                background: "#1a1a2e",
                color: "#e5e7eb",
                textAlign: "center",
                fontSize: "14px",
            }}>
                <div style={{ fontWeight: 600, marginBottom: "4px" }}>
                    {"\uD83D\uDCCD"} {"\u0423\u043a\u0430\u0436\u0438\u0442\u0435 \u0432\u0430\u0448\u0443 \u043f\u043e\u0437\u0438\u0446\u0438\u044e"}
                </div>
                <div style={{ fontSize: "12px", color: "#9ca3af" }}>
                    {"\u041d\u0430\u0436\u043c\u0438\u0442\u0435 \u043d\u0430 \u043a\u0430\u0440\u0442\u0443 \u0433\u0434\u0435 \u0432\u044b \u0441\u0435\u0439\u0447\u0430\u0441 \u043d\u0430\u0445\u043e\u0434\u0438\u0442\u0435\u0441\u044c"}
                </div>
            </div>

            <div style={{ flex: 1 }}>
                <MapContainer
                    center={center}
                    zoom={13}
                    style={{ width: "100%", height: "100%" }}
                >
                    <TileLayer
                        attribution='&copy; OpenStreetMap'
                        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                    />
                    <LocationClickHandler onLocationSelect={setSelectedLocation} />
                    {selectedLocation && (
                        <CircleMarker
                            center={selectedLocation}
                            pathOptions={{ color: "#10b981", fillColor: "#10b981", fillOpacity: 0.8 }}
                            radius={8}
                        />
                    )}
                </MapContainer>
            </div>

            <div style={{ padding: "12px 16px", background: "#1a1a2e" }}>
                <button
                    onClick={saveLocation}
                    disabled={!selectedLocation || saving || saved}
                    style={{
                        width: "100%",
                        padding: "14px",
                        borderRadius: "12px",
                        border: "none",
                        background: selectedLocation && !saved ? "#10b981" : "#374151",
                        color: "#fff",
                        fontSize: "16px",
                        fontWeight: 600,
                        cursor: selectedLocation && !saved ? "pointer" : "default",
                        opacity: saving ? 0.7 : 1,
                    }}
                >
                    {saved ? "\u2705 \u0421\u043e\u0445\u0440\u0430\u043d\u0435\u043d\u043e!" : saving ? "\u0421\u043e\u0445\u0440\u0430\u043d\u044f\u0435\u043c..." : "\uD83D\uDCCD \u0421\u043e\u0445\u0440\u0430\u043d\u0438\u0442\u044c \u043f\u043e\u0437\u0438\u0446\u0438\u044e"}
                </button>
            </div>
        </div>
    );
};

export default DriverLocationPicker;
